<template>
<fragment>
    <el-button type="text" @click="obnCancelBtn">放弃</el-button>
    <contractManagementOneCancelDialog :visible.sync="visible" :row="row" @ok="ok"/>
</fragment>
</template>

<script>
import contractManagementOneCancelDialog from './contractManagementOneCancelDialog'
export default {
    components: {
        contractManagementOneCancelDialog
    },
    props:{
        row:{
            type:Object,
            default:()=>({})
        }
    },
    data() {
        return {
            visible: false
        };
    },
    methods: {
        ok() {
            this.$emit('ok')
        },
        async obnCancelBtn() {
            this.visible = true
        }
    }
};
</script>
